"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  components: {
    Page: _Page.default
  },
  data: function data() {
    return {
      host_wiser: process.env.VUE_APP_HOST_WISER || 'http://142.93.51.38:8080',
      loadActive: true,
      activeTab: 0,
      tabsDisplayed: [],
      fullscreen: false,
      autoTab: true,
      window: {
        width: 0,
        height: 0
      },
      config: {
        type: 'report',
        settings: {
          panes: {
            filters: {
              visible: false
            },
            pageNavigation: {
              visible: true
            }
          }
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)({
    menuItemsFarm: 'menuItemsFarm',
    farm: 'GET_FARM',
    response: 'GET_TABS'
  })), {}, {
    ID_FAZENDA: function ID_FAZENDA() {
      return this.farm.id;
    },
    planidName: function planidName() {
      return this.response.plan ? this.response.plan.plan.name : ' -- ';
    },
    showPlanPrata: function showPlanPrata() {
      return this.planidName === 'PLANO PRATA';
    },
    showPlanOuro: function showPlanOuro() {
      return this.planidName === 'PLANO OURO';
    },
    showPlanDiamante: function showPlanDiamante() {
      return this.planidName === 'PLANO DIAMANTE';
    }
  }),
  created: function created() {
    // this.loopRecursive();
    // this.loopRecursiveAutoTab()
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return this.fetchTabs(this.farm.id);
          case 1:
            this.startReports();
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    activeTab: function activeTab(val) {
      if (!this.tabsDisplayed.includes(val)) {
        this.setActiveTab(val);
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['setLoading', 'fetchTabs'])), {}, {
    embeddedSetting: function embeddedSetting(ts) {},
    printReport: function printReport() {
      var tab = this.response.tabs[this.activeTab];
      var activeID = tab.id;
      var element = document.getElementById(activeID);
      /* eslint-disable */
      var report = powerbi.get(element);
      /* eslint-enable */

      try {
        report.print();
      } catch (error) {
        console.log('error: ', error);
      }
    },
    timeout: function timeout(ms) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    sleep: function () {
      var _sleep = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fn) {
        var _len,
          args,
          _key,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.timeout(900000);
            case 1:
              for (_len = _args2.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args2[_key];
              }
              return _context2.a(2, this[fn].apply(this, args));
          }
        }, _callee2, this);
      }));
      function sleep(_x) {
        return _sleep.apply(this, arguments);
      }
      return sleep;
    }(),
    sleepAutoTab: function () {
      var _sleepAutoTab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(fn) {
        var _len2,
          args,
          _key2,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.timeout(30000);
            case 1:
              for (_len2 = _args3.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = _args3[_key2];
              }
              return _context3.a(2, this[fn].apply(this, args));
          }
        }, _callee3, this);
      }));
      function sleepAutoTab(_x2) {
        return _sleepAutoTab.apply(this, arguments);
      }
      return sleepAutoTab;
    }(),
    activeItem: function activeItem() {
      var self = this;
      self.loadActive = false;
      self.setLoading(true);
      setTimeout(function () {
        self.loadActive = true;
        self.loopRecursive();
        self.setLoading(false);
      }, 2000);
    },
    activeAutoTab: function activeAutoTab() {
      var self = this;
      if (self.autoTab) {
        if (self.response.tabs) {
          var listSize = self.response.tabs.length - 1;
          self.activeTab = self.activeTab === listSize ? 0 : self.activeTab + 1;
        }
      }
      setTimeout(function () {
        self.loopRecursiveAutoTab();
      }, 2000);
    },
    loopRecursive: function () {
      var _loopRecursive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.sleep('activeItem');
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function loopRecursive() {
        return _loopRecursive.apply(this, arguments);
      }
      return loopRecursive;
    }(),
    loopRecursiveAutoTab: function () {
      var _loopRecursiveAutoTab = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.sleepAutoTab('activeAutoTab');
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function loopRecursiveAutoTab() {
        return _loopRecursiveAutoTab.apply(this, arguments);
      }
      return loopRecursiveAutoTab;
    }(),
    toggle: function toggle() {
      this.$refs['fullscreen'].toggle();
    },
    fullscreenChange: function fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    handleResize: function handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    startReports: function startReports() {
      var _this = this;
      setTimeout(function () {
        var tab = _this.response.tabs[0];
        var reportDiv = document.getElementById(tab.id);
        if (tab.linkFrame) {
          var url = new URL(tab.linkFrame);
          if (url.searchParams.get('reportId')) {
            var reportId = url.searchParams.get('reportId');
            reportDiv.setAttribute('powerbi-report-id', reportId);
          }
        }
        /* eslint-disable */
        powerbi.embed(reportDiv, _this.config);
        /* eslint-enable */
        _this.setLoading(false);
        _this.tabsDisplayed.push(0);
      }, 3000);
    },
    setActiveTab: function setActiveTab(index) {
      var _this2 = this;
      this.setLoading(true);
      setTimeout(function () {
        var tab = _this2.response.tabs[index];
        var reportDiv = document.getElementById(tab.id);
        if (tab.linkFrame) {
          var url = new URL(tab.linkFrame);
          if (url.searchParams.get('reportId')) {
            var reportId = url.searchParams.get('reportId');
            reportDiv.setAttribute('powerbi-report-id', reportId);
          }
        }
        /* eslint-disable */
        powerbi.embed(reportDiv, _this2.config);
        /* eslint-enable */
        _this2.setLoading(false);
        _this2.tabsDisplayed.push(index);
      }, 1000);
    },
    showTabContent: function showTabContent(index) {
      if (this.tabsDisplayed.includes(index)) return true;
      if (this.activeTab === index) return true;
      return false;
    }
  })
};